import { inject, injectable, named } from '@patsnap/tahiti-core/shared/inversify';
import type { ExternalRenderer } from './patsnap-copilot-service.interface';
import { ContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';

export const PatsnapCopilotIntentRendererContribution = Symbol.for('PatsnapCopilotIntentRendererContribution');

export interface PatsnapCopilotIntentRenderer extends ExternalRenderer {

}

export interface PatsnapCopilotIntentRendererConstructor {
    new (): PatsnapCopilotIntentRenderer;
}

export interface PatsnapCopilotIntentRendererContribution {
    registerRenderer(register: PatsnapCopilotIntentRendererRegistry): void;
}

export interface PatsnapCopilotIntent {
    intent: string;
}

export const PatsnapCopilotIntentRendererRegistry = Symbol.for('PatsnapCopilotIntentRendererRegistry');

export interface PatsnapCopilotIntentRendererRegistry {
    onStart: () => void;
    removeRenderer(data: PatsnapCopilotIntent): void;
    getRenderer(data: PatsnapCopilotIntent): PatsnapCopilotIntentRendererConstructor | undefined;
    registerRenderer(data: PatsnapCopilotIntent, renderer: PatsnapCopilotIntentRendererConstructor): void;
}

@injectable()
export class PatsnapCopilotIntentRendererRegistryImpl implements PatsnapCopilotIntentRendererRegistry {
    constructor(
        @inject(ContributionProvider) @named(PatsnapCopilotIntentRendererContribution)
        private _contributionProvider: ContributionProvider<PatsnapCopilotIntentRendererContribution>,
    ) {
        //
    }

    onStart(): void {
        this._contributionProvider.getContributions().forEach(contribution => {
            contribution.registerRenderer(this);
        });
    }

    private _renderers: Map<string, PatsnapCopilotIntentRendererConstructor> = new Map<string, PatsnapCopilotIntentRendererConstructor>();

    registerRenderer(data: PatsnapCopilotIntent, renderer: PatsnapCopilotIntentRendererConstructor): void {
        this._renderers.set(data.intent, renderer);
    }

    getRenderer(data: PatsnapCopilotIntent): PatsnapCopilotIntentRendererConstructor | undefined {
        return this._renderers.get(data.intent);
    }

    removeRenderer(data: PatsnapCopilotIntent): void {
        this._renderers.delete(data.intent);
    }
}
